import { render, staticRenderFns } from "./Airticketyuding.vue?vue&type=template&id=992feeb2&scoped=true"
import script from "./Airticketyuding.vue?vue&type=script&lang=js"
export * from "./Airticketyuding.vue?vue&type=script&lang=js"
import style0 from "./Airticketyuding.vue?vue&type=style&index=0&id=992feeb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992feeb2",
  null
  
)

export default component.exports